<template>
  <v-card flat class="mt-2">
    <v-card-text>
      <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate></v-progress-circular>
      </v-overlay>
      <canvas v-show="data.length > 0" :id="chartId"> </canvas>
      <v-row v-show="data.length <= 0" align="center" justify="center">
        <v-icon small class="mr-1">fa-exclamation-circle</v-icon>
        <span>Pas de données pour la période sélectionnée</span>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Chart from "chart.js";
import { round10 } from "round10";
export default {
  name: "AnalycticTransactionChart",
  props: {
    chartId: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    totalSales: {
      type: Number,
      required: true
    },
    totalCost: {
      type: Number,
      required: true
    }
  },
  mounted() {
    this.createChart();
  },
  data() {
    return {
      chart: undefined
    };
  },
  methods: {
    createChart() {
      const ctx = document.getElementById(this.chartId);
      this.chart = new Chart(ctx, {
        type: "polarArea",
        data: {
          datasets: [
            {
              label: "Cost (%)",
              data: this.data.map(x => {
                if (this.totalCost !== 0) {
                  return round10((x.cost / this.totalCost) * 100, -2);
                } else {
                  return 0;
                }
              }),

              backgroundColor: [
                "#003f5c",
                "#2f4b7c",
                "#665191",
                "#a05195",
                "#EF9A9A",
                "#d45087",
                "#f95d6a",
                "#ff7c43",
                "#ffa600",
                "#D50000",
                "#F57C00",
                "#003f5c",
                "#2f4b7c",
                "#665191",
                "#a05195",
                "#EF9A9A",
                "#d45087",
                "#f95d6a",
                "#ff7c43",
                "#ffa600",
                "#D50000",
                "#F57C00"
              ]
            },
            {
              label: "Vente (%)",
              data: this.data.map(x => {
                if (this.totalSales !== 0) {
                  return round10((x.retail_price / this.totalSales) * 100, -2);
                } else {
                  return 0;
                }
              }),
              backgroundColor: [
                "#003f5c55",
                "#2f4b7c55",
                "#66519155",
                "#a0519555",
                "#EF9A9A55",
                "#d4508755",
                "#f95d6a55",
                "#ff7c4355",
                "#ffa60055",
                "#D5000055",
                "#F57C0055",
                "#003f5c55",
                "#2f4b7c55",
                "#66519155",
                "#a0519555",
                "#EF9A9A55",
                "#d4508755",
                "#f95d6a55",
                "#ff7c4355",
                "#ffa60055",
                "#D5000055",
                "#F57C0055"
              ]
            }
          ],
          labels: this.data.map(x => x.tag)
        },
        options: {
          responsive: true,
          legend: {
            display: true,
            position: "left"
          },
          tooltips: {
            mode: "point",
            callbacks: {
              title(tooltipItem, data) {
                if (tooltipItem.length > 0) {
                  return `${data.labels[tooltipItem[0].index]}`;
                } else {
                  return "";
                }
              },
              label(tooltipItem, data) {
                let label = data.datasets[tooltipItem.datasetIndex].label || "";
                return `${label}: ${tooltipItem.yLabel}`;
              }
            }
          }
        }
      });
    },
    updateChart() {
      this.chart.data.datasets[0].data = this.data.map(x => {
        if (this.totalCost !== 0) {
          return round10((x.cost / this.totalCost) * 100, -2);
        } else {
          return 0;
        }
      });
      this.chart.data.datasets[1].data = this.data.map(x => {
        if (this.totalSales !== 0) {
          return round10((x.retail_price / this.totalSales) * 100, -2);
        } else {
          return 0;
        }
      });
      this.chart.data.labels = this.data.map(x => x.tag);
      this.chart.update();
    }
  },
  watch: {
    loading() {
      this.updateChart();
    },
    attribute() {
      this.updateChart();
    },
    totalCost() {
      this.updateChart();
    }
  }
};
</script>

<style lang="scss" scoped></style>
